import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'Raphael-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Output() openMenu=new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

}
